// Ячейка Figma «Menu Cell»: иконка или логотип в сером круге 40, заголовок 16/21, подпись 12/16, справа — значение 15/20
// и шеврон (отступ справа 8) или своя иконка (отступ 12, напр. галочка выбранного языка). Выбранная ячейка — заголовок
// полужирным. Группа ячеек — белая карточка radius 16 с разделителями 0.5. Иконки Figma тёмные: рисуем маской цветом
// текста, чтобы они перекрашивались в тёмной теме.
import type { ReactNode } from 'react';
import caretRight from '../assets/icons/caret-right.svg';
import styles from './MenuCell.module.css';

export function MaskIcon({ src, size = 24 }: { src: string; size?: number }) {
  const url = `url("${src}")`;
  return <span className={styles.mask} style={{ width: size, height: size, maskImage: url, WebkitMaskImage: url }} aria-hidden="true" />;
}

export function MenuGroup({ children }: { children: ReactNode }) {
  return <section className={styles.group}>{children}</section>;
}

export function MenuCell({ icon, media, title, subtitle, value, trailing, selected, onClick, chevron = Boolean(onClick) && !trailing, danger, lang, wrapTitle }: {
  icon?: string; media?: ReactNode; title: ReactNode; subtitle?: ReactNode; value?: ReactNode;
  /** Своя иконка справа вместо шеврона (24, отступ 12). */
  trailing?: ReactNode;
  /** Выбранная ячейка (Figma «Selected=YES»): заголовок полужирный. */
  selected?: boolean;
  onClick?: () => void; chevron?: boolean; danger?: boolean;
  /** Язык заголовка (название языка на самом языке). */
  lang?: string;
  /** Заголовок переносится по словам до 2 строк вместо одной строки с многоточием (имена игроков при крупном шрифте). */
  wrapTitle?: boolean;
}) {
  const right = value || chevron
    ? <span className={styles.right}>
        {value && <span className={styles.value}>{value}</span>}
        {chevron && <span className={styles.chevron}><MaskIcon src={caretRight} size={20} /></span>}
      </span>
    : null;
  const body = (
    <>
      {(icon || media) && <span className={styles.icon}>{media ?? <MaskIcon src={icon!} />}</span>}
      <span className={styles.text}>
        <span className={`${styles.title}${wrapTitle ? ` ${styles.wrapTitle}` : ''} ${selected ? styles.selected : ''}`} lang={lang}>{title}</span>
        {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
      </span>
      {right}
      {trailing && <span className={styles.trailing}>{trailing}</span>}
    </>
  );
  const cls = `${styles.cell} ${danger ? styles.danger : ''}`;
  return onClick
    ? <button className={cls} onClick={onClick} aria-pressed={selected}>{body}</button>
    : <div className={cls}>{body}</div>;
}
